import {
  MinusCircleOutlined,
  PlusOutlined,
  CarOutlined,
  DollarOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
} from "antd";
import {
  carTypeOptions,
  fuelType,
} from "pages/Family/components/constants/constants";
import React from "react";

const CarsForm = () => {
  return (
    <Form.List name="cars">
      {(fields, { add, remove }) => (
        <div className="space-y-6">
          {fields.map(({ key, name, ...restField }, index) => (
            <Card
              key={key}
              title={
                <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
                  <CarOutlined /> بيانات المركبة {index + 1}
                </span>
              }
              bordered={false}
              className="shadow-sm bg-gray-50"
              extra={
                <Button
                  type="text"
                  danger
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(name)}
                >
                  حذف المركبة
                </Button>
              }
            >
              {/* 🚗 Vehicle Info */}
              <Divider orientation="right" plain>
                معلومات المركبة
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "type"]}
                    label="النوع"
                    rules={[{ required: true, message: "اختر النوع" }]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر نوع المركبة"
                      options={carTypeOptions}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "fuelType"]}
                    label="نوع الوقود"
                    rules={[{ required: true, message: "اختر نوع الوقود" }]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر نوع الوقود"
                      options={fuelType}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "plateNumber"]}
                    label="رقم اللوحة"
                  >
                    <Input placeholder="أدخل رقم اللوحة" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "make"]}
                    label="الشركة المصنعة"
                  >
                    <Input placeholder="أدخل الشركة المصنعة" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "model"]}
                    label="الطراز"
                  >
                    <Input placeholder="أدخل الطراز" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "year"]}
                    label="سنة الصنع"
                  >
                    <Input
                      type="number"
                      inputMode="numeric"
                      placeholder="أدخل سنة الصنع"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "color"]}
                    label="اللون"
                  >
                    <Input placeholder="أدخل لون المركبة" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "vin"]}
                    label="رقم الهيكل (VIN)"
                  >
                    <Input placeholder="أدخل رقم الهيكل" />
                  </Form.Item>
                </Col>
              </Row>

              {/* 📅 Registration Info */}
              <Divider orientation="right" plain>
                التسجيل والتقدير المالي
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "registrationDate"]}
                    label="تاريخ التسجيل"
                  >
                    <DatePicker className="w-full" format="DD-MM-YYYY" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "estimatedValue"]}
                    label="القيمة التقديرية"
                  >
                    <Input
                      type="number"
                      inputMode="numeric"
                      placeholder="أدخل القيمة التقديرية"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* 📝 Notes */}
              <Divider orientation="right" plain>
                ملاحظات إضافية
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24}>
                  <Form.Item
                    {...restField}
                    name={[name, "notes"]}
                    label="ملاحظات"
                  >
                    <Input.TextArea
                      rows={2}
                      placeholder="أدخل أي ملاحظات إضافية حول المركبة"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Button
                type="dashed"
                danger
                onClick={() => remove(name)}
                icon={<MinusCircleOutlined />}
              >
                حذف المركبة
              </Button>
            </Card>
          ))}

          {/* ➕ Add Car Button */}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              إضافة مركبة
            </Button>
          </Form.Item>
        </div>
      )}
    </Form.List>
  );
};

export default CarsForm;
